import { bindCursorActions } from '../cursors/bindCursorActions';
import * as UnboundCursorActions from '../cursors/actions';

export const SearchCursorActions = bindCursorActions(
  UnboundCursorActions,
  'map.search'
);
